import { Certification } from '../../../../../../../resources/agency/domain/types/Agency';
import { IllustrationBcorp } from '../illustrations/Bcorp';
import { IllustrationTourCertCertified } from '../illustrations/TourCertCertified';
import { IllustrationTourCertQualified } from '../illustrations/TourCertQualified';
import { IllustrationTravelifeCertified } from '../illustrations/TravelifeIconCertified';
import { IllustrationTravelifePartner } from '../illustrations/TravelifeIconPartner';

export const getIconByCertification = (certification: Array<Certification>) => {
    return certification.map((certification) => {
        switch (certification.key) {
            case 'b-corp':
                return <IllustrationBcorp key={certification.key} width="56px" />;
            case 'tourcert':
                if (certification.level === 'Certified') {
                    return <IllustrationTourCertCertified key={certification.key} width="66px" />;
                }
                if (certification.level === 'Qualified') {
                    return <IllustrationTourCertQualified key={certification.key} width="100px" />;
                }
                return null;
            case 'travelife':
                if (certification.level === 'Certified') {
                    return <IllustrationTravelifeCertified key={certification.key} width="120px" />;
                }
                if (certification.level === 'Qualified') {
                    return <IllustrationTravelifePartner key={certification.key} width="120px" />;
                }
                break;
            default:
                return null;
        }
    });
};
